/**
 * Module dependencies.
 */

import { useRequestProvider } from 'app/components/providers/request-provider/request-provider';
import { resolveAppUrl } from 'app/core/utils/url-resolver';
import { AxiosInstance } from 'axios';
import { useMutation } from '@tanstack/react-query';

/**
 * `Payload` type.
 */

type Payload = {
  apiKey: string;
  phoneNumber: string;
  pin: string;
};

/**
 * Post phoneNumber.
 */

export async function postPhoneNumber(client: AxiosInstance, payload: Payload): Promise<string> {
  const { phoneNumber, pin, apiKey } = payload;

  return await client
    .post(
      resolveAppUrl('integrationsConsentPhoneNumberConfirm'),
      {
        phoneNumber,
        pin
      },
      {
        headers: {
          'X-Api-Secret': apiKey
        }
      }
    )
    .then(({ data }) => data.data);
}

/**
 * Export `usePostConsentPhoneNumberConfirm`.
 */

export function usePostConsentPhoneNumberConfirm() {
  const client = useRequestProvider();

  return useMutation({
    mutationFn: async (payload: Payload) => {
      return await postPhoneNumber(client, payload);
    }
  });
}
